/** Regelversion 12: Erfahrungsstufen (Auswahl, Landingpage, Aufstiegsangebot). */
import { LEVELS } from '../engine/level12';

const KEY = 'kabinett-stufe';
/** Stufe aus dem Orden-Speicher (features/medals/store, Schlüssel `_stufe`), ohne den Supabase-Client zu laden. */
function savedLevel(): number { try { const m = /^stufe-(\d)$/.exec(JSON.parse(localStorage.getItem('kabinett-orden') || '{}')?._stufe?.diff || ''); return m ? +m[1] : 0; } catch { return 0; } }
/** Höchste Stufe, die schon gespielt wurde: im Browser und, mit Konto, im Profil (bei den Orden). */
export function rememberedLevel(): number { let v = 0; try { v = Number(localStorage.getItem(KEY)) || 0; } catch { /* privater Modus */ } v = Math.max(v, savedLevel()); return v >= 1 && v <= 4 ? v : 1; }
export function rememberLevel(l: number) { try { if (l > (Number(localStorage.getItem(KEY)) || 0)) localStorage.setItem(KEY, String(l)); } catch { /* privater Modus */ } saveLevelLocal(l); }
/** Stufe beim Orden-Speicher ablegen. Mit Konto schiebt syncMedals sie beim nächsten Start ins Profil. */
function saveLevelLocal(l: number) {
  try { const e = JSON.parse(localStorage.getItem('kabinett-orden') || '{}') || {}; if (savedLevel() >= l) return; e._stufe = { at: new Date().toISOString(), party: '', diff: `stufe-${l}` }; localStorage.setItem('kabinett-orden', JSON.stringify(e)); } catch { /* privater Modus */ }
}

export function LevelCards({ value, onPick }: { value?: number; onPick?: (l: number) => void }) {
  return (
    <div className="lp-diffs lp-levels">{LEVELS.map((d) => {
      const body = <><span className="label">Stufe {d.l} · {d.tag}</span><b className="lp-dn">{d.n}</b>
        <ul>{d.pts.map((p) => <li key={p}>{p}</li>)}</ul></>;
      return onPick
        ? <button type="button" key={d.l} className="lp-diff tcard" aria-pressed={value === d.l} onClick={() => onPick(d.l)}>{body}{value === d.l && <span className="lp-sel">Ausgewählt</span>}</button>
        : <div key={d.l} className="lp-diff">{body}</div>;
    })}</div>
  );
}
